import { WSMessageT } from './types';

export type ParsedWSMessageT = Omit<WSMessageT, 'dataJson' | 'eventName'> & {
  dataJson: unknown;
  eventName: WSMessageT['eventName'] | string;
  eventNameV3?: string;
};

const tryParseJson = (value: string): unknown | null => {
  try {
    return JSON.parse(value) as unknown;
  } catch {
    return null;
  }
};

const parseIfJsonString = (value: unknown): unknown | null => {
  if (typeof value === 'string') {
    return tryParseJson(value);
  }

  return value;
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object';
};

export const deserializeWsMessage = (
  message: unknown,
): ParsedWSMessageT | null => {
  const parsedMessage = parseIfJsonString(message);

  if (!isRecord(parsedMessage)) {
    return null;
  }

  return parsedMessage as ParsedWSMessageT;
};

export const deserializeWsDataJson = <T>(dataJson: unknown): T | null => {
  const parsedData = parseIfJsonString(dataJson);

  if (parsedData === null) {
    return null;
  }

  return parsedData as T;
};
